import { createContext, useContext, useState, useCallback } from "react";
import { getEmployeesStatuses } from "@/api/core";

const EmployeesContext = createContext();

export const EmployeesProvider = ({ children }) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Загрузка списка сотрудников
  const loadEmployees = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const employeesData = await getEmployeesStatuses();
      setEmployees(employeesData || []);
    } catch (err) {
      console.error("Не удалось загрузить список сотрудников:", err);
      setError(err);
      setEmployees([]); // Устанавливаем пустой список при ошибке
    } finally {
      setLoading(false);
    }
  }, []);

  // Обновление статуса конкретного сотрудника
  const updateEmployeeStatus = useCallback((updatedEmployee) => {
    setEmployees((prevEmployees) => {
      const employeeIndex = prevEmployees.findIndex(
        (emp) => emp.employee_uuid === updatedEmployee.employeeUuid
      );

      if (employeeIndex !== -1) {
        // Обновляем существующего сотрудника
        const newEmployees = [...prevEmployees];
        newEmployees[employeeIndex] = {
          ...newEmployees[employeeIndex],
          employee_uuid: updatedEmployee.employeeUuid,
          status: updatedEmployee.status,
        };
        return newEmployees;
      } else {
        // Добавляем нового сотрудника, если его не было в списке
        return [
          ...prevEmployees,
          {
            employee_uuid: updatedEmployee.employeeUuid,
            status: updatedEmployee.status,
          },
        ];
      }
    });
  }, []);

  // Очистка списка (при выходе из системы)
  const clearEmployees = useCallback(() => {
    setEmployees([]);
    setError(null);
  }, []);

  const value = {
    employees,
    loading,
    error,
    loadEmployees,
    updateEmployeeStatus,
    clearEmployees,
  };

  return (
    <EmployeesContext.Provider value={value}>
      {children}
    </EmployeesContext.Provider>
  );
};

// Хук для использования контекста
export const useEmployees = () => {
  const context = useContext(EmployeesContext);
  if (!context) {
    throw new Error(
      "useEmployees должен использоваться внутри EmployeesProvider"
    );
  }
  return context;
};
